import { useSelector } from 'react-redux';

export const usePreference = (key, defaultValue) => useSelector((state) => state.session.user[key] || defaultValue);

export const useAttributePreference = (key, defaultValue) => useSelector((state) => state.session.user.attributes[key] || defaultValue);
